import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SelectedIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SelectedIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M9.06501 17.7426H9.05671C8.92097 17.7401 8.79206 17.683 8.69929 17.5834L4.13435 12.6888C3.94587 12.4872 3.9571 12.1708 4.15925 11.9823C4.36091 11.7943 4.67683 11.8046 4.86579 12.0072L9.07673 16.5219L19.1456 6.40467C19.3409 6.20985 19.6583 6.20789 19.8526 6.40272C20.0484 6.59754 20.0494 6.91395 19.8546 7.10975L9.4195 17.5951C9.32526 17.6898 9.19782 17.7426 9.06501 17.7426Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SelectedIcon;
